import React from "react";
import { StyledImage } from "./styled";

export default function Image(props) {
    return (
        <StyledImage src={props.src} style={props.style} {...props} />
    )
}